import 'expo-router/entry'
import './src/utils/unistyles' // <-- file that initializes Unistyles
